<template>
  <div>
    <div class="flex flex-col lg:flex-row flex-wrap justify-between items-center mb-8 border-b-2 border-gray-light -mt-2 pb-2">
    <h1 class="flex items-baseline m-1">
      {{ title }}
      <span class="text-xl font-normal text-gray ml-2">({{ itemsTotal }})</span>
    </h1>
    <div class="flex flex-wrap justify-center lg:justify-end w-full flex-1">
      <slot name="before-actions"></slot>
      <vue-button v-if="filters"
                  class="btn btn-outline btn-primary m-1"
                  icon="filter"
                  @click="$modal.open(`${resource}-filters`)">Filtrer</vue-button>

      <filter-search v-if="search" class="m-1 max-w-xs" param="search" input-class="bg-white" @applied="$parent.fetch"/>
      <slot name="after-actions"></slot>
    </div>
  </div>

  <div class="collection">
    <div class="collection-item" v-for="item in $parent.items" :key="item.id">
      <slot :item="item"></slot>
    </div>
  </div>

  <paginator class="my-8 justify-center"
             :data-set="$parent.dataSet"
             :loading="$parent.fetching"
             @changed="$parent.fetch"/>
  </div>
</template>

<script>
import { ucfirst } from '../../core/helpers';
import FilterSearch from '../filters/FilterSearch.vue';
import Paginator from '../Paginator.vue';

const titleMap = {
  products: 'produits',
  families: 'familles',
  shops: 'boutiques',
  customers: 'clients',
  orders: 'commandes',
  recurrences: 'récurrences',
  users: 'utilisateurs',
  carts: 'paniers',
  notifications: 'notifications',
};

export default {
  props: {
    filters: {
      type: Boolean,
      default: true,
    },
    search: {
      type: Boolean,
      default: true,
    },
  },

  components: { Paginator, FilterSearch },

  computed: {
    itemsTotal() {
      return Object.keys(this.$parent.dataSet).length
        ? this.$parent.dataSet.meta.total
        : 0;
    },

    resource() {
      return this.$parent.route.split('.')[1];
    },

    title() {
      return ucfirst(titleMap[this.resource]);
    },
  },
};
</script>